import styled from "styled-components";
import { Col } from "react-bootstrap";
import { PrimaryButton } from "components/Button/style";

export const Card = styled.div`
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.neutral10};
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
`;

export const HeaderBotoes = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const FormContainer = styled.div`
  margin-top: 1.5rem;

  select {
    border-radius: 8px;
    height: 38px;
  }
`;

export const InputContainer = styled(Col)`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
`;

export const DatePickerContainer = styled.div`
  display: grid;
  gap: 0.3rem;
  width: 100%;
`;

export const AcoesFiltroContainer = styled.div`
  position: relative;
  padding-top: 1.7rem;
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const AcoesContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const InputContainerMaisFiltros = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  display: grid;
  height: 60px;
`;

export const Button = styled(PrimaryButton)`
  width: 100px;
`;

export const InputBuscaProcesso = styled.div`
  position: relative;
  width: 100%;

  svg {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    color: ${({ theme }) => theme.colors.neutral.neutral70};
    pointer-events: none;
  }

  input {
    width: 100%;
    height: 38px;
    padding: 0 32px 0 10px;
    border: 1px solid ${({ theme }) => theme.colors.neutral.neutral30};
    border-radius: 8px;
    outline: none;
  }
`;

export const TabelaContainer = styled.div`
  margin-top: 1rem;

  .rdt_Table {
    padding-bottom: 16px;
  }
`;

export const Placeholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 360px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral10};
  color: ${({ theme }) => theme.colors.neutral.neutral70};
  font-size: 0.95rem;
  border-radius: 4px;
`;
